module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-140687726-1","head":false,"anonymize":false,"respectDNT":false,"exclude":[],"pageTransitionDelay":0},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Узи Centrum Мелитополь","short_name":"УЗИ","lang":"ru-RU","display":"browser","icon":"src/images/icon.jpg","theme_color":"#16405C","background_color":"#525252","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e77b315bae4aa5328cb0ccb0ba0b7095"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
